import $axios from "../../api";

// Tab Rekonsiliasi di /offline-stores/order (t2610-0024).
//
// Modul TERPISAH dari OrderStores, bukan tambahan di dalamnya: OrderStores
// menyimpan state tab Daftar Order (page, view, orderList) yang di-reset di
// beforeDestroy halaman. Menumpangkan state matriks di sana berarti dua tab
// saling menimpa nomor halaman masing-masing.

const emptyMeta = () => ({
    start_date: null,
    end_date: null,
    dates: [],
    overdue_days: 5,
    page: 1,
    per_page: 20,
    total: 0,
    last_page: 1,
    sort_by: "store",
    sort_desc: false,
    // Urutan dua baris sumber ditentukan backend supaya "mengurutkan kolom
    // Sumber" berarti hal yang sama di kedua sisi.
    source_order: ["pos", "sap"],
});

const emptyTally = () => ({
    stores: 0,
    match: 0,
    different: 0,
    overdue_sap: 0,
    pending_sap: 0,
    no_closing: 0,
});

const state = () => ({
    isLoading: false,
    rows: [],
    meta: emptyMeta(),
    tally: emptyTally(),
    page: 1,

    areaList: [],

    detail: null,
    detailLoading: false,

    // Penanda urutan permintaan. Tanpa ini, respons permintaan LAMA yang datang
    // belakangan (filter cepat diganti dua kali) menimpa hasil yang benar —
    // pola reqSeq yang sama dipakai halaman dashboard setelah bug serupa.
    reqSeq: 0,
});

const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    ASSIGN_MATRIX(state, payload) {
        state.rows = payload.data || [];
        state.meta = payload.meta || emptyMeta();
        state.tally = { ...emptyTally(), ...(payload.tally || {}) };
    },
    RESET_MATRIX(state) {
        state.rows = [];
        state.meta = emptyMeta();
        state.tally = emptyTally();
    },
    SET_PAGE(state, payload) {
        state.page = payload;
    },
    ASSIGN_FILTER_OPTIONS(state, payload) {
        state.areaList = payload.areas || [];
    },
    SET_DETAIL_LOADING(state, payload) {
        state.detailLoading = payload;
    },
    ASSIGN_DETAIL(state, payload) {
        state.detail = payload;
    },
    BUMP_REQ_SEQ(state) {
        state.reqSeq += 1;
    },
};

const actions = {
    getMatrix({ commit, state, dispatch }, payload) {
        commit("BUMP_REQ_SEQ");
        const seq = state.reqSeq;

        commit("SET_LOADING", true);

        return $axios
            .get(`order/store/reconciliation?${payload || ""}`)
            .then((res) => {
                if (seq !== state.reqSeq) return; // respons basi — abaikan
                commit("ASSIGN_MATRIX", res.data);
                commit("SET_LOADING", false);
            })
            .catch((error) => {
                if (seq !== state.reqSeq) return;
                commit("RESET_MATRIX");
                commit("SET_LOADING", false);
                dispatch("Main/globalSweetAlert", error.response, { root: true });
            });
    },

    getFilterOptions({ commit, dispatch }) {
        return $axios
            .get(`order/store/reconciliation/areas`)
            .then((res) => {
                commit("ASSIGN_FILTER_OPTIONS", res.data.data || {});
            })
            .catch((error) => {
                dispatch("Main/globalSweetAlert", error.response, { root: true });
            });
    },

    getDetail({ commit, dispatch }, { storeCode, date }) {
        commit("SET_DETAIL_LOADING", true);
        commit("ASSIGN_DETAIL", null);

        return $axios
            .get(`order/store/reconciliation/detail?store_code=${encodeURIComponent(storeCode)}&date=${encodeURIComponent(date)}`)
            .then((res) => {
                commit("ASSIGN_DETAIL", res.data.data);
                commit("SET_DETAIL_LOADING", false);
            })
            .catch((error) => {
                commit("SET_DETAIL_LOADING", false);
                dispatch("Main/globalSweetAlert", error.response, { root: true });
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
